interface SummaryEmptyProps {
  onSummaryClick?: () => void;
}

export default function SummaryEmpty({ onSummaryClick }: SummaryEmptyProps) {

  const handleSummaryClick = () => {
    onSummaryClick?.();
  };

  return (
    <div className="flex flex-col items-center mt-30">
      <div className="text-4 font-500 text-#191D26 opacity-30">纪要·发言人观点·章节</div>
      <div className="text-3 font-400 text-#191D26 mt-3 text-center opacity-30">
        轻松掌握关键信息，告别手动整理的繁琐与低效<br />为工作和学习节省更多宝贵时间
      </div>
      <div className="relative w-30.5 h-9 mt-6 rounded-2.5 cursor-pointer" onClick={handleSummaryClick}>
          <div
            className="flex flex-items-center flex-justify-center h-9.5 px-3.5 rd-2.5 cursor-pointer"
            style={{
              background:
                "linear-gradient(#f2f3f5, #f2f3f5) padding-box, linear-gradient(45deg, #4981F2, #9984F7, #CD84F4) border-box",
              border: "1px solid transparent",
            }}
          >
            <div className="w-full h-full rounded-lg flex items-center justify-center">
              <span
                className="text-sm font-medium"
                style={{
                  background: "linear-gradient(45deg, #A28CE2, #80B0FF)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                AI 帮我总结
              </span>
            </div>
          </div>
        </div>
    </div>
  );
}
